import { render, staticRenderFns } from "./FormTagihan.vue?vue&type=template&id=7382c71d&"
import script from "./FormTagihan.vue?vue&type=script&lang=js&"
export * from "./FormTagihan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports